/**
 * Cliente para a API publica de artigos (chefia/api/v1/artigos.php),
 * servida em /api no mesmo dominio do site. Sem cookie de sessao: e
 * conteudo publico, sem necessidade de credenciais.
 */

export interface Artigo {
  id: number;
  slug: string;
  titulo: string;
  resumo: string | null;
  capa: string | null;
  autor: string | null;
  publicadoEm: string | null;
  /** 'html' (padrao, usa `conteudo`) ou 'pdfEmbed' (embute o PDF de `ebookUrl` em vez do HTML). */
  displayMode?: 'html' | 'pdfEmbed';
  /** Numero de acessos ao detalhe do artigo, incrementado pela API a cada leitura. */
  visitas?: number;
  conteudo?: string | null;
  ebookUrl?: string | null;
  ebookTitulo?: string | null;
}

export interface Paginacao {
  pagina: number;
  limite: number;
  total: number;
  totalPaginas: number;
}

export class ApiError extends Error {
  status: number;
  constructor(message: string, status: number) {
    super(message);
    this.status = status;
  }
}

// No servidor (ex: artigos/[slug]/layout.tsx, generateMetadata) fetch()
// precisa de URL absoluta - nao ha "documento atual" para resolver um
// caminho relativo, ao contrario do browser. Mesmo padrao de cases-api.ts/
// store-api.ts/sitemap.ts.
const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL || 'https://enqdigital.com.br';

async function call<T>(path: string, init?: RequestInit): Promise<T> {
  const url = typeof window === 'undefined' ? `${SITE_URL}${path}` : path;
  const res = await fetch(url, init);
  const data = await res.json().catch(() => ({}));

  if (!res.ok) {
    throw new ApiError(data.error || 'Nao foi possivel completar a operacao.', res.status);
  }

  return data as T;
}

export function listarArtigos(
  params: {
    pagina?: number;
    limite?: number;
    locale?: string;
  } = {}
): Promise<{ artigos: Artigo[]; paginacao: Paginacao }> {
  const qs = new URLSearchParams();
  if (params.pagina) qs.set('pagina', String(params.pagina));
  if (params.limite) qs.set('limite', String(params.limite));
  if (params.locale) qs.set('locale', params.locale);
  return call(`/api/v1/artigos.php?${qs.toString()}`);
}

export function buscarArtigo(slug: string, locale?: string): Promise<{ artigo: Artigo }> {
  const qs = new URLSearchParams({ slug });
  if (locale) qs.set('locale', locale);
  return call(`/api/v1/artigos.php?${qs.toString()}`);
}

export function dataArtigoBr(iso: string | null): string {
  if (!iso) return '';
  const d = new Date(iso.replace(' ', 'T'));
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
}
